// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e6c73b1b","703":"f3326ac7"}[chunkId] + ".chunk.js";
};